module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/valentinstag-9904792b09583df8fb6b79e9b7c935ca.svg";